// 生成状态/结果字段清单：撤销保护 + 复制清空 共用的单一数据源
// - useUndoHistory: undo 时保留这些字段（生成状态/结果不可撤销）
// - useClipboard.spawnCopies: 复制时清空其中的"生成状态"子集（taskId 等），保留"生成结果"子集
// 后续新增生成结果字段（如未来 3D 模型 url）只需在此处追加，避免两处漂移

// 生成状态字段：复制时需清空，撤销时需保留（不撤销）
export const GENERATION_STATUS_FIELDS = [
  'taskId',
  'pendingTaskId',
  'progress',
  'error',
  'isManualUpload',
] as const;

// 生成结果字段：复制时保留（副本携带结果），撤销时不撤销（保留当前结果）
// imageDimensions 同属自动探测结果（前端异步加载图片/视频尺寸回写），
// 不应被 undo 覆盖；且加入保护后 undo 恢复保留当前值，使 saveHistory 去重检查
// （current == history[idx+1]）能正确识别 undo 后的异步副作用，避免历史污染。
export const GENERATION_RESULT_FIELDS = [
  'image',
  'images',
  'videoUri',
  'videoUris',
  'audioUri',
  'analysis',
  'panoramaOutputUrl',
  'videoMetadata',
  'imageDimensions',
  'duration',
  'panoramaOutputDimensions',
  // 脚本节点成品数据（ScriptData 单一数据源，含镜头/资产/提示词，撤销不回滚）
  'script',
  // 智能剪辑剪辑文档（EditDocument 单一数据源，撤销不回滚——防画布级 Ctrl+Z 清空剪辑中文档，
  // 同脚本节点 v1.4.4 风险；方案 §4.10 数据持久化决策）
  'editDocument',
] as const;

// 用户编辑内容字段：撤销时不撤销（保留当前文本内容）
// 富文本编辑采用编辑会话模型，打字仅持久化不记历史。
// 若 undo 恢复旧快照时覆盖这些字段，会导致预览模式下按 Ctrl+Z 清空文本内容。
// 加入保护后，undo 保留当前文本，仅撤销结构/位置等变更。
export const EDIT_CONTENT_FIELDS = [
  'richContent',
  'textContent',
] as const;

// 撤销保护字段全集 = 生成状态 + 生成结果 + 编辑内容（undo 时这些字段保留当前值，不被历史快照覆盖）
export const PROTECTED_FIELDS = [
  ...GENERATION_STATUS_FIELDS,
  ...GENERATION_RESULT_FIELDS,
  ...EDIT_CONTENT_FIELDS,
] as const;

// 从对象中挑选指定键（类型安全）
export function pick<T extends object, K extends string>(
  obj: T,
  keys: readonly K[],
): Partial<Record<K, unknown>> {
  const out: Partial<Record<K, unknown>> = {};
  for (const k of keys) {
    if (k in obj) {
      (out as Record<K, unknown>)[k] = (obj as Record<K, unknown>)[k];
    }
  }
  return out;
}
